/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { getContributors } from '../../actions';

class Contributors extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this.props.getContributors();
  }

  // eslint-disable-next-line class-methods-use-this
  helper(listofA) {
    if (listofA.length !== 0) {
      return (
        <ul>
          {listofA.map((Author) => {
            return (
              <li key={Author.id} className="author">
                <NavLink className="author-link" key={Author.id} to={`/profile/${Author.id}`}>
                  <p>{Author.name}</p>
                </NavLink>
              </li>
            );
          })}
        </ul>
      );
    } else {
      return (<div className="no-author">No contributors yet!</div>);
    }
  }

  renderBooksTitles() {
    //   for loop that goes the fetch books
    return (
      <div>
        {this.props.contributorsList.map((object) => {
          const book = object.Book;
          const listofA = object.Contributors;
          if (book.title !== 'Contributors') {
            return (
              <div key={object.Book.id}>
                <h1 className="contributors-book">{book.title}</h1>
                {this.helper(listofA)}
                <div id="container-divider" />
              </div>
            );
          } else {
            return (<div key={object.Book.id} />);
          }
        })}
      </div>
    );
  }

  render() {
    return (
      <div className="contributors-container">
        <h1 className="contributors-title">Contributors</h1>
        {this.renderBooksTitles()}
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    contributorsList: state.contributors.all,
  }
);
export default withRouter(connect(mapStateToProps, { getContributors })(Contributors));
